module.exports = __webpack_public_path__ + "static/FAccT-806f247c3cd4395557dad3dfecb2eb80.png";